/**
 * Ryan O'Dowd
 * 2024-09-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    progressBar: (isComplete) => ({ // @TODO: combine with Assignment.styles (should probably make this its own compoennt for how much it's used)
      width: 100, // @TODO: magic
      height: globalScale * 10,
      borderWidth: globalScale * 3,
      borderStyle: 'solid',
      borderColor: isComplete ? colors.accentDark : colors.primary,
      borderRadius: globalScale * 8,
    }),
  };
};

export default getStyles;
